import styles from './battery.module.css';
import DOMPurify from 'dompurify';
const Battery = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text35']),
        }}
      ></h1>
      <h5
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text36']),
        }}
      ></h5>

      <h6
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text37']),
        }}
      ></h6>
      <div className={styles.batteryCard}>
        <div className={styles.batteryProductBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-battery.jpg"
            alt=""
          />
        </div>
        <div className={styles.line}></div>
        <div className={styles.dataBox}>
          <div>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text38']),
              }}
            ></h5>
            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text39']),
              }}
            ></h2>
          </div>
          <div className={styles.dataIetmLine}></div>
          <div>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text40']),
              }}
            ></h5>
            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text41']),
              }}
            ></h2>
          </div>
          <div className={styles.dataIetmLine}></div>
          <div>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text42']),
              }}
            ></h5>
            <h2
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text43']),
              }}
            ></h2>
          </div>
        </div>
        {/* <div className={styles.dataBox}>
          <div className={styles.dataItem}>
            <div className={styles.dataItemHeader}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.35413 16.8491L5.56559 12.9118C5.8238 12.0726 6.59914 11.5 7.47715 11.5H16.5229C17.4009 11.5 18.1762 12.0726 18.4344 12.9118L19.6459 16.8491C19.8637 17.5571 19.6724 18.3276 19.1485 18.8515L18.5858 19.4142C18.2107 19.7893 17.702 20 17.1716 20H6.82843C6.29799 20 5.78929 19.7893 5.41421 19.4142L4.85147 18.8515C4.32763 18.3276 4.13626 17.5571 4.35413 16.8491Z"
                  stroke="#2F3133"
                  stroke-width="2"
                />
                <path
                  d="M8.5 14C7.94772 14 7.5 14.4477 7.5 15C7.5 15.5523 7.94772 16 8.5 16V14ZM15.5 16C16.0523 16 16.5 15.5523 16.5 15C16.5 14.4477 16.0523 14 15.5 14V16ZM8.5 16H15.5V14H8.5V16Z"
                  fill="#2F3133"
                />
                <path
                  d="M9 11.9994C9 1.5 15 1.49947 15 12.0008"
                  stroke="#2F3133"
                  stroke-width="2"
                />
              </svg>

              <h3>手提袋模式</h3>
            </div>
            <div
              className={styles.barBox}
              style={{
                '--effect-data-progress': '100%',
              }}
            >
              <div className={styles.bar}></div>
            </div>

            <h2>3h 30min</h2>
          </div>

          <div className={styles.dataItem}>
            <div className={styles.dataItemHeader}>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5 6H7.5C6.39543 6 5.5 6.89543 5.5 8V18C5.5 19.1046 6.39543 20 7.5 20H17.5C18.6046 20 19.5 19.1046 19.5 18V8C19.5 6.89543 18.6046 6 17.5 6Z"
                  stroke="#2F3133"
                  stroke-width="2"
                />
                <path
                  d="M16 6V7H17V6H16ZM9 6H8V7H9V6ZM11 4H14V2H11V4ZM15 5V6H17V5H15ZM16 5H9V7H16V5ZM10 6V5H8V6H10ZM14 4C14.5523 4 15 4.44772 15 5H17C17 3.34315 15.6569 2 14 2V4ZM11 2C9.34315 2 8 3.34315 8 5H10C10 4.44772 10.4477 4 11 4V2Z"
                  fill="#2F3133"
                />
                <path
                  d="M10.5 20C10.5 19.4477 10.0523 19 9.5 19C8.94772 19 8.5 19.4477 8.5 20H10.5ZM8.5 21C8.5 21.5523 8.94772 22 9.5 22C10.0523 22 10.5 21.5523 10.5 21H8.5ZM8.5 20V21H10.5V20H8.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10H10ZM8 16C8 16.5523 8.44772 17 9 17C9.55228 17 10 16.5523 10 16H8ZM8 10V16H10V10H8Z"
                  fill="#2F3133"
                />
                <path
                  d="M13.5 10C13.5 9.44772 13.0523 9 12.5 9C11.9477 9 11.5 9.44772 11.5 10H13.5ZM11.5 16C11.5 16.5523 11.9477 17 12.5 17C13.0523 17 13.5 16.5523 13.5 16H11.5ZM11.5 10V16H13.5V10H11.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M17 10C17 9.44772 16.5523 9 16 9C15.4477 9 15 9.44772 15 10H17ZM15 16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16H15ZM15 10V16H17V10H15Z"
                  fill="#2F3133"
                />
                <path
                  d="M16.5 20C16.5 19.4477 16.0523 19 15.5 19C14.9477 19 14.5 19.4477 14.5 20H16.5ZM14.5 21C14.5 21.5523 14.9477 22 15.5 22C16.0523 22 16.5 21.5523 16.5 21H14.5ZM14.5 20V21H16.5V20H14.5Z"
                  fill="#2F3133"
                />
              </svg>

              <h3>行李箱模式</h3>
            </div>
            <div
              className={styles.barBox}
              style={{
                '--effect-data-progress': '80%',
              }}
            >
              <div className={styles.bar}></div>
            </div>

            <h3>2h 40min</h3>
          </div>

          <div className={styles.dataItem}>
            <div className={styles.dataItemHeader}>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5 4H6.5C5.39543 4 4.5 4.89543 4.5 6V17C4.5 18.1046 5.39543 19 6.5 19H18.5C19.6046 19 20.5 18.1046 20.5 17V6C20.5 4.89543 19.6046 4 18.5 4Z"
                  stroke="#2F3133"
                  stroke-width="2"
                />
                <path
                  d="M8.5 19C8.5 18.4477 8.05228 18 7.5 18C6.94772 18 6.5 18.4477 6.5 19H8.5ZM6.5 20C6.5 20.5523 6.94772 21 7.5 21C8.05228 21 8.5 20.5523 8.5 20H6.5ZM6.5 19V20H8.5V19H6.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M18.5 19C18.5 18.4477 18.0523 18 17.5 18C16.9477 18 16.5 18.4477 16.5 19H18.5ZM16.5 20C16.5 20.5523 16.9477 21 17.5 21C18.0523 21 18.5 20.5523 18.5 20H16.5ZM16.5 19V20H18.5V19H16.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M13.5 9C13.5 8.44772 13.0523 8 12.5 8C11.9477 8 11.5 8.44772 11.5 9H13.5ZM11.5 19C11.5 19.5523 11.9477 20 12.5 20C13.0523 20 13.5 19.5523 13.5 19H11.5ZM11.5 9V19H13.5V9H11.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M13.5 4C13.5 3.44772 13.0523 3 12.5 3C11.9477 3 11.5 3.44772 11.5 4H13.5ZM11.5 5C11.5 5.55228 11.9477 6 12.5 6C13.0523 6 13.5 5.55228 13.5 5H11.5ZM11.5 4V5H13.5V4H11.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M10.5 10.5C10.5 9.94772 10.0523 9.5 9.5 9.5C8.94772 9.5 8.5 9.94772 8.5 10.5H10.5ZM8.5 13.5C8.5 14.0523 8.94772 14.5 9.5 14.5C10.0523 14.5 10.5 14.0523 10.5 13.5H8.5ZM8.5 10.5V13.5H10.5V10.5H8.5Z"
                  fill="#2F3133"
                />
                <path
                  d="M16.5 10.5C16.5 9.94772 16.0523 9.5 15.5 9.5C14.9477 9.5 14.5 9.94772 14.5 10.5H16.5ZM14.5 13.5C14.5 14.0523 14.9477 14.5 15.5 14.5C16.0523 14.5 16.5 14.0523 16.5 13.5H14.5ZM14.5 10.5V13.5H16.5V10.5H14.5Z"
                  fill="#2F3133"
                />
              </svg>

              <h3>橱柜模式</h3>
            </div>
            <div
              className={styles.barBox}
              style={{
                '--effect-data-progress': '60%',
              }}
            >
              <div className={styles.bar}></div>
            </div>

            <h4>1h 20min</h4>
          </div>

          <div className={styles.dataItem}>
            <div className={styles.dataItemHeader}>
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.84156 10.7524C10.2572 11.1161 10.889 11.074 11.2526 10.6583C11.6163 10.2427 11.5742 9.61095 11.1586 9.24726L9.84156 10.7524ZM15.1585 13.2475C14.7429 12.8839 14.1111 12.926 13.7474 13.3416C13.3838 13.7573 13.4259 14.389 13.8415 14.7527L15.1585 13.2475ZM11.1586 9.24726C8.07027 6.54492 5.38651 5.88555 3.41027 7.06239C1.54459 8.17339 0.922865 10.5971 1.13033 12.6026C1.33862 14.6161 2.46378 16.8627 4.82979 17.3102C7.12013 17.7434 9.95495 16.3361 13.2446 12.6666L11.7554 11.3316C8.54507 14.9126 6.3799 15.568 5.20148 15.3451C4.09874 15.1365 3.28641 14.0083 3.11971 12.3968C2.95219 10.7773 3.51798 9.326 4.43356 8.78078C5.23859 8.3014 6.92984 8.20458 9.84156 10.7524L11.1586 9.24726ZM13.2446 12.6666C16.455 9.08559 18.6201 8.43029 19.7985 8.65324C20.9012 8.86189 21.7136 9.99032 21.8803 11.602C22.0479 13.2217 21.4821 14.6733 20.5664 15.2187C19.7614 15.6982 18.0702 15.7952 15.1585 13.2475L13.8415 14.7527C16.9299 17.4549 19.6137 18.1141 21.5899 16.937C23.4555 15.8257 24.0772 13.4019 23.8697 11.3962C23.6614 9.38261 22.5363 7.13577 20.1703 6.68811C17.8799 6.25476 15.0451 7.66209 11.7554 11.3316L13.2446 12.6666Z"
                  fill="#2F3133"
                />
              </svg>

              <h3>循环模式</h3>
            </div>
            <div
              className={styles.barBox}
              style={{
                '--effect-data-progress': '40%',
              }}
            >
              <div className={styles.bar}></div>
            </div>

            <h5>30min</h5>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Battery;
